export const AgentLinePlay = ({
  currentColor = '#000',
  ...props
}: { currentColor?: string } & React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    style={{ color: currentColor }}
  >
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill={currentColor}
      fillOpacity="0.64"
      data-figma-bg-blur-radius="10.5"
    />
    <path
      d="M9.6543 12V7.75L13.3349 9.875L17.0155 12L13.3349 14.125L9.6543 16.25V12Z"
      fill="#fff"
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="1.8403"
    />
    <defs>
      <clipPath id="bgblur_0_4298_2059_clip_path" transform="translate(10.5 10.5)">
        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" />
      </clipPath>
    </defs>
  </svg>
);
